import { colors, font } from '@chegg-ui/theme';
export var InputHorizonStyles = {
  input: {
    color: colors.dark,
    'font-size': font.size.px16,
    background: 'transparent',
    'box-sizing': 'border-box',
    border: 'none',
    'border-image': 'initial',
    'font-family': font.family["default"],
    width: '100%',
    'line-height': font.lineHeight.xs,
    'text-overflow': 'ellipsis',
    padding: '2rem 0px calc(0.5rem - 2px)',
    display: 'block'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/constants/ThemeConstants.js
// module id = 4589
// module chunks = 11